<section>
  <kl-program-training-form [postDetails]="dialogData?.data?.postDetails" (postCreated)="ok()"></kl-program-training-form>
</section>
